// Single source of truth for the dynamic import() of every route that is
// not needed for the very first paint (Home, Header, Footer, Breadcrumbs
// stay eager). App.js wraps each of these in React.lazy(); Header.js and
// Footer.js call the same functions on link hover/focus so the chunk is
// already warm by the time the user clicks (see prefetchRoute below).
const routeImports = {
  "/about": () => import("./Pages/About.js"),
  "/krmangalam-university": () => import("./Pages/KRMU.js"),
  "/developers": () => import("./Components/DeveloperTeam.js"),
  "/forgot-password": () => import("./Auth/ForgotPassword.js"),
  "/contact": () => import("./Pages/ContactForm.js"),
  "/archives": () => import("./Pages/Archives.js"),
  "/current-issue": () => import("./Pages/CurrentIssue.js"),
  "/abstracting-indexing": () => import("./Pages/AbstractingandIndexing.js"),
  "/editorial-leadership": () => import("./Pages/EditorialBoard.js"),
  "/reviewers": () => import("./Pages/Reviewers.js"),
  "/author-guidelines": () => import("./Pages/AuthorGuidelines.js"),
  "/author-guidelines/latex-template": () => import("./Pages/LatexTemplate.js"),
  "/privacy-policy": () => import("./Pages/PrivacyPolicy.js"),
  "/terms-and-conditions": () => import("./Pages/TermsandConditions.js"),
  "/ethics": () => import("./Pages/Ethics.js"),
  "/itme-policies-framework": () => import("./Pages/ITMEPoliciesFramework.js"),
  "/form": () => import("./Pages/Form.js"),
  "/login": () => import("./Auth/Login.js"),
  "/signup": () => import("./Auth/Signup.js"),
  "/dashboard": () => import("./Pages/Dashboard.js"),
  "/reviewer/dashboard": () => import("./Pages/ReviewerDashboard.js"),
  "/profile": () => import("./Pages/Profile.js"),
  "/admin": () => import("./Admin/Admin.js"),
};

const warmed = new Set();

// Kicks off the chunk's download without waiting for it. Safe to call
// repeatedly — each route is only ever fetched once.
export function prefetchRoute(path) {
  const load = routeImports[path];
  if (!load || warmed.has(path)) return;
  warmed.add(path);
  load().catch(() => {
    // A failed prefetch (offline, flaky network) is not fatal — the
    // normal React.lazy suspense load on navigation will retry.
    warmed.delete(path);
  });
}

export default routeImports;
